<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Consulta de Movimiento y Fondo a rendir
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Consulta de Movimiento y Fondo a rendir</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col" style="max-width: 300px;">
        <div class="md-form mb-0">
          <mdb-select
            [options]="optionsEstado"
            [multiple]="true"
            [filterEnabled]="true"
            [highlightFirst]="false"
            placeholder="Seleccionar Estado"
          ></mdb-select>
          <label>Estado</label>
        </div>
      </div>

      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <mdb-date-picker
            [inline]="true"
            name="fechaDesde"
            [placeholder]="'Desde'"
            required
          ></mdb-date-picker>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <mdb-date-picker
            [inline]="true"
            name="fechahasta"
            [placeholder]="'Hasta'"
            required
          ></mdb-date-picker>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6;"
  >
    <div></div>
    <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">RUT</th>
            <th scope="col">Recibido por</th>
            <th scope="col">Monto entregado</th>
            <th scope="col">Monto recibido</th>
            <th scope="col">Saldo a Rendir</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>9.999.999-9</td>
            <td>Amira Runolfsson</td>
            <td align="right">15.000</td>
            <td align="right">9.500</td>
            <td align="right">5.500</td>
          </tr>
          <tr>
            <td>9.999.999-9</td>
            <td>Ms. Parker Oberbrunner</td>
            <td align="right">15.000</td>
            <td align="right">9.500</td>
            <td align="right">5.500</td>
          </tr>
          <tr>
            <td>9.999.999-9</td>
            <td>Flavio Steuber</td>
            <td align="right">15.000</td>
            <td align="right">9.500</td>
            <td align="right">5.500</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
